export const WELL_EVENTS_PAGE_LOADED = 'WELL_EVENTS_PAGE_LOADED';
